import { DEEPLINK_PARAMETERS } from '../../app/constants';
import { WEBKIT_ENGINE } from '../../app/types/enums';


export const generatorDeeplink = ({ webViewDeeplink, url }) => (
  `${webViewDeeplink}?webkit-engine=${WEBKIT_ENGINE.V_2}&url=${encodeURIComponent(url)}`
    + `&use_web_title=${DEEPLINK_PARAMETERS.USE_WEB_TITLE.FALSE}`
    + `&bar_left_button_style=${DEEPLINK_PARAMETERS.BAR_LEFT_BUTTON_STYLE.BACK}`
    + `&search_mode=${DEEPLINK_PARAMETERS.SEARCH_MODE.NONE}`
    + `&loading_mode=${DEEPLINK_PARAMETERS.LOADING_MODE.NONE}`
    + `&hides_bottom_bar=${DEEPLINK_PARAMETERS.HIDE_BOTTOM_BAR.TRUE}`
    + `&bar_elevation=${DEEPLINK_PARAMETERS.BAR_ELEVATION.NONE}`
);

